export default "__VITE_ASSET__CnPwaS6h__"